// extracted by mini-css-extract-plugin
export default {"multiWrapper":"MetricsWidgetWrapper_multiWrapper__6+L84"};